import LoanAgreement from 'components/user/individualSchoolSteps/LoanAgreement';
import SectionLayout from 'layouts/SectionLayout';

const LoanAgreementPage = () => {
  return (
    <SectionLayout>
      <LoanAgreement />
    </SectionLayout>
  );
};

export default LoanAgreementPage;
